import React, { useState, useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faCaretDown,
  faUser,
  faAdd,
  faList,
  faUniversity,
  faSchool,
  faWallet,
  faDonate,
  faQrcode,
  faFileInvoice,
  faArrowRight,
  faUserTie,
  faBuildingColumns,
  faHandHoldingDollar,
  faClipboard,
  faEllipsisVertical,
  faSearch,
  faXmark,
  faBell,
  faMaximize,
  faGear,
  faInbox,
  faTasks,
  faSlidersH,
  faSignIn,
  faChevronRight,
  faHome,
  faGraduationCap,
  faFile,
} from "@fortawesome/free-solid-svg-icons";
import "./Admin.css";

import { Scissors } from "lucide-react";
import axios from "axios";

const Admin = () => {
  const navigate = useNavigate();
  const [isSidebarExpanded, setSidebarExpanded] = useState(true);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const [showoption, setShowoption] = useState(false);

  const [isSearchVisible, setSearchVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearchIconVisible, setSearchIconVisible] = useState(true);
  const [customizersetting, setcustomizersetting] = useState(false);
 const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API}/wallet/pending-count`)
      .then(res => setPendingCount(res.data.pendingCount))
      .catch(err => console.error(err));
  }, []);
  const handlecustomizer = () => {
    setcustomizersetting(!customizersetting);
  };

  const handleInputChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const toggleSearchForm = () => {
    setSearchVisible(!isSearchVisible);
    setSearchIconVisible(!isSearchIconVisible); // Toggle visibility of the search icon
  };

  // const [isSearchVisible, setSearchVisible] = useState(false);
  // const [searchQuery, setSearchQuery] = useState("");

  // const handleInputChange = (e) => {
  //   setSearchQuery(e.target.value);
  // };

  // const toggleSearchForm = () => {
  //   setSearchVisible(!isSearchVisible);
  // };
  const toggleSidebar = () => {
    setSidebarExpanded(!isSidebarExpanded);
  };

  const toggleDropdown = (dropdown) => {
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
  };
  const handleshow = () => {
    setShowoption(!showoption);
  };
  const handlelogout = () => {
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("isInstitutionLogin");
    localStorage.removeItem("isStudentLogin");

    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("username");
    localStorage.removeItem("userRole");
    localStorage.removeItem("referralid");
    navigate("/");
    window.location.reload(); // Reload to update the UI after logout
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 992) {
        setSidebarExpanded(false);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const user = localStorage.getItem("userRole");

  // if (user !=='supperadmin') return <p>You are not an superadmin ..</p>;

  // if (user !== 'supperadmin' && user !== 'admin') return <p>You are not an admin ..</p>;

  return (
    <div>
      <div className="page-wrapper compact-wrapper" id="pageWrapper">
        <div
          className="page-main-header"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <div className="main-header-right">
            <div className="main-header-left">
              <div className="logo-wrapper">
                {/* <NavLink to='/'><img src="./assets/logo.png" alt="Logo" style={{ height: '50px' }} /></<NavLink> */}
                <NavLink to="/">
                  <img
                    src="./assets/logo.png"
                    alt="Logo"
                    style={{ height: "50px" }}
                  />{" "}
                </NavLink>
              </div>
            </div>
            <div className="mobile-sidebar">
              <div className="flex-grow-1 text-end switch-sm">
                <label className="switch">
                  <input
                    id="sidebar-toggle"
                    type="checkbox"
                    onChange={toggleSidebar}
                    checked={isSidebarExpanded}
                  />
                  <span className="switch-state"></span>
                </label>
              </div>
            </div>
            <div className="nav-right col pull-right right-menu">
              <ul className="nav-menus">
                <li className="px-0">
                  {/* Search form */}
                  <form
                    className={`form-inline search-form ${
                      isSearchVisible ? "d-block" : "d-none"
                    }`}
                  >
                    <input
                      type="text"
                      className="form-control-plaintext"
                      placeholder="Search....."
                      value={searchQuery}
                      onChange={handleInputChange}
                      aria-label="Search input"
                    />
                    <FontAwesomeIcon
                      icon={faXmark}
                      className="close-search"
                      onClick={toggleSearchForm} // Clicking cancel hides the search form
                      aria-label="Close search"
                    />
                  </form>

                  {/* Mobile search icon */}
                  {isSearchIconVisible && (
                    <span
                      className="mobile-search"
                      onClick={toggleSearchForm} // Clicking the search icon shows the form
                      aria-label="Open search form"
                    >
                      <FontAwesomeIcon icon={faSearch} />
                    </span>
                  )}
                </li>
                <li className="onhover-dropdown">
                  <FontAwesomeIcon icon={faBell} />
                  <ul className="notification-dropdown onhover-show-div">
                    <li className="d-block">
                      <h6 className="f-w-600">Notifications</h6>
                      <span className="f-12">You have 0 unread messages</span>
                    </li>
                    <li className="bg-light txt-dark">
                      <a>All notifications</a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a
                    className="text-dark"
                    href="#!"
                    onClick={() => document.documentElement.requestFullscreen()}
                  >
                    <FontAwesomeIcon icon={faMaximize} />
                  </a>
                </li>

                {localStorage.getItem("userRole") === "institute" && (
                  <li>
                    <Link className="text-dark" to="/walletpage">
                      <FontAwesomeIcon icon={faWallet} />
                    </Link>
                  </li>
                )}

                <li className="theme-setting" onClick={handlecustomizer}>
                  <FontAwesomeIcon icon={faGear} />
                </li>
                <li className="onhover-dropdown px-0">
                  <span className="d-flex user-header">
                    <img
                      className="me-2 rounded-circle img-35"
                      src="user.png"
                      alt="User"
                    />
                    <span className="flex-grow-1">
                      <span className="f-12 f-w-600">
                        {localStorage.getItem("userRole")}
                      </span>
                      <span className="d-block">
                        {localStorage.getItem("username")}
                      </span>
                    </span>
                  </span>
                  <ul className="profile-dropdown onhover-show-div">
                    <li>
                      <FontAwesomeIcon icon={faUser} /> Profile
                    </li>
                    <NavLink to="/">
                      <li className="f-w-600">
                        <FontAwesomeIcon icon={faHome} /> Home
                      </li>
                    </NavLink>
                    <li className="f-12">
                      <FontAwesomeIcon icon={faChevronRight} />
                      <FontAwesomeIcon icon={faInbox} className="ms-2" /> Inbox
                    </li>
                    <li className="f-12">
                      <FontAwesomeIcon icon={faChevronRight} />
                      <FontAwesomeIcon icon={faTasks} className="ms-2" />{" "}
                      Taskboard
                    </li>
                    <li className="f-12">
                      <FontAwesomeIcon icon={faChevronRight} />
                      <FontAwesomeIcon
                        icon={faSlidersH}
                        className="ms-2"
                      />{" "}
                      Settings
                    </li>
                    <li onClick={handlelogout}>
                      <FontAwesomeIcon icon={faSignIn} /> Log out
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div
              className="d-lg-none mobile-toggle pull-right"
              onClick={handleshow}
            >
              <FontAwesomeIcon icon={faEllipsisVertical} size="lg" />
            </div>
          </div>
          {showoption && (
            <div className="mobile-nav-right">
              <ul className="nav-menus">
                <li className="px-0">
                  <form className="form-inline search-form">
                    <input
                      className="form-control-plaintext"
                      placeholder="Search....."
                    />
                    <FontAwesomeIcon icon={faXmark} className="close-search" />
                  </form>
                  <span className="mobile-search">
                    <FontAwesomeIcon icon={faSearch} />
                  </span>
                </li>
                <li className="onhover-dropdown">
                  <FontAwesomeIcon icon={faBell} />
                  <ul className="notification-dropdown onhover-show-div">
                    <li className="d-block">
                      <h6 className="f-w-600">Notifications</h6>
                      <span className="f-12">You have 2 unread messages</span>
                    </li>
                    <li className="bg-light txt-dark">
                      <a href="#">All notifications</a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a
                    className="text-dark"
                    href="#!"
                    onClick={() => document.documentElement.requestFullscreen()}
                  >
                    <FontAwesomeIcon icon={faMaximize} />
                  </a>
                </li>
                <li className="theme-setting">
                  <FontAwesomeIcon icon={faGear} />
                </li>
                <li className="onhover-dropdown px-0">
                  <span className="d-flex user-header">
                    <img
                      className="me-2 rounded-circle img-35"
                      src="user.png"
                      alt="User"
                    />
                    <span className="flex-grow-1">
                      <span className="f-12 f-w-600">
                        {localStorage.getItem("userRole")}
                      </span>
                      <span className="d-block">
                        {localStorage.getItem("username")}
                      </span>
                    </span>
                  </span>
                  <ul
                    className="profile-dropdown onhover-show-div"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <li>
                      <FontAwesomeIcon icon={faUser} /> Profile
                    </li>
                    <NavLink to="/">
                      <li className="f-w-600">
                        <FontAwesomeIcon icon={faHome} /> Home
                      </li>
                    </NavLink>
                    <li className="f-12">
                      <FontAwesomeIcon icon={faChevronRight} />
                      <FontAwesomeIcon icon={faInbox} className="ms-2" /> Inbox
                    </li>
                    <li className="f-12">
                      <FontAwesomeIcon icon={faChevronRight} />
                      <FontAwesomeIcon icon={faTasks} className="ms-2" />{" "}
                      Taskboard
                    </li>
                    <li className="f-12">
                      <FontAwesomeIcon icon={faChevronRight} />
                      <FontAwesomeIcon
                        icon={faSlidersH}
                        className="ms-2"
                      />{" "}
                      Settings
                    </li>
                    <li onClick={handlelogout}>
                      <FontAwesomeIcon icon={faSignIn} /> Log out
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          )}
        </div>

        <div className="page-body-wrapper sidebar-icon">
          <header
            className="main-nav"
            style={{
              width: isSidebarExpanded ? "250px" : "70px",
              transition: "width 0.3s ease-in-out",
              height: "100vh",
            }}
          >
            <nav>
              <div className="main-navbar">
                <div className="left-arrow" id="left-arrow">
                  <i data-feather="arrow-left"></i>
                </div>
                <div id="mainnav" className="sidepage">
                  {isSidebarExpanded ? (
                    <ul>
                      {localStorage.getItem("userRole") === "supperadmin" ? (
                        <li>
                          <h6
                            style={{
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              paddingRight: "10px",
                            }}
                            onClick={() => toggleDropdown("admin")}
                          >
                            Admin
                            <FontAwesomeIcon
                              icon={faCaretDown}
                              rotation={activeDropdown === "admin" ? 0 : 270} // Rotate the icon when dropdown is open
                            />
                          </h6>
                          {/* Dropdown for Admin */}
                          {activeDropdown === "admin" && (
                            <ul className="admin_dropdown">
                              <li>
                                <Link to="/adminadd">
                                  <h6>Admin Add</h6>
                                </Link>
                              </li>
                              <li>
                                <Link to="/adminform">
                                  <h6>Admin Form</h6>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </li>
                      ) : (
                        <></>
                      )}

                      {/* {(localStorage.getItem("userRole") === "supperadmin" ||
                        localStorage.getItem("userRole") === "admin") && (
                        <li>
                          <h6
                            style={{
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              paddingRight: "10px",
                            }}
                            onClick={() => toggleDropdown("institution")}
                          >
                            Institution
                            <FontAwesomeIcon
                              icon={faCaretDown}
                              rotation={
                                activeDropdown === "institution" ? 0 : 270
                              } 
                            />
                          </h6>
                          
                          {activeDropdown === "institution" && (
                            <ul className="admin_dropdown">
                              <li>
                                <Link to="/institutionform">
                                  <h6>Institution Add</h6>
                                </Link>
                              </li>
                              <li>
                                <Link to="/institution">
                                  <h6>Institution Form</h6>
                                </Link>
                              </li>
                            </ul>
                          )}
                        </li>
                      )} */}
                      {(localStorage.getItem("userRole") === "supperadmin" ||
                        localStorage.getItem("userRole") === "admin") && (
                        <li>
                          <h6
                            style={{
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              paddingRight: "10px",
                            }}
                            onClick={() => toggleDropdown("students")}
                          >
                            Students
                            <FontAwesomeIcon
                              icon={faCaretDown}
                              rotation={activeDropdown === "students" ? 0 : 270} // Rotate the icon when dropdown is open
                            />
                          </h6>
                          {/* Dropdown for Students */}
                          {activeDropdown === "students" && (
                            <ul className="admin_dropdown">
                              <li>
                                <a href="#">
                                  <h6>Student Add</h6>
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <h6>Student Form</h6>
                                </a>
                              </li>
                            </ul>
                          )}
                        </li>
                      )}
                      <li>
                        <h6
                          style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            paddingRight: "10px",
                          }}
                        >
                          <Link to={"/"}>Home</Link>

                          <FontAwesomeIcon
                            icon={faCaretDown}
                            rotation={activeDropdown === "students" ? 0 : 270} // Rotate the icon when dropdown is open
                          />
                        </h6>
                      </li>
                    </ul>
                  ) : (
                    // Small Navigation when the sidepage is hidden
                    <ul className="small-nav-icons">
                      {localStorage.getItem("userRole") === "supperadmin" ? (
                        <li>
                          <NavLink>
                            <FontAwesomeIcon
                              icon={faUser}
                              className="nav-icon"
                              onClick={() => toggleDropdown("admin")}
                            />
                          </NavLink>

                          {activeDropdown === "admin" && (
                            <ul className="admin_dropdownicon">
                              <li>
                                <Link to="/adminadd">
                                  <FontAwesomeIcon
                                    icon={faUser}
                                    className="nav-icon"
                                    style={{ fontSize: "19px" }}
                                  />
                                  <FontAwesomeIcon
                                    icon={faAdd}
                                    className="nav-icon"
                                    style={{ fontSize: "19px" }}
                                  />{" "}
                                </Link>
                              </li>
                              <li>
                                <Link to="/adminform">
                                  <FontAwesomeIcon
                                    icon={faUser}
                                    className="nav-icon"
                                    style={{ fontSize: "19px" }}
                                  />
                                  <FontAwesomeIcon
                                    icon={faList}
                                    className="nav-icon"
                                    style={{ fontSize: "19px" }}
                                  />{" "}
                                </Link>
                              </li>
                            </ul>
                          )}
                        </li>
                      ) : (
                        <></>
                      )}

                      {/* {(localStorage.getItem("userRole") === "supperadmin" ||
                        localStorage.getItem("userRole") === "admin") && (
                        <li>
                          <NavLink>
                            <FontAwesomeIcon
                              icon={faUniversity}
                              className="nav-icon"
                              onClick={() => toggleDropdown("institution")}
                            />
                          </NavLink>
                          {activeDropdown === "institution" && (
                            <ul className="admin_dropdownicon">
                              <li>
                                <Link to="/institution">
                                  <FontAwesomeIcon
                                    icon={faUniversity}
                                    className="nav-icon"
                                    style={{ fontSize: "19px" }}
                                  />
                                  <FontAwesomeIcon
                                    icon={faAdd}
                                    className="nav-icon"
                                    style={{ fontSize: "19px" }}
                                  />{" "}
                                </Link>
                              </li>
                              <li>
                                <Link to="/institutionform">
                                  <FontAwesomeIcon
                                    icon={faUniversity}
                                    className="nav-icon"
                                    style={{ fontSize: "19px" }}
                                  />
                                  <FontAwesomeIcon
                                    icon={faList}
                                    className="nav-icon"
                                    style={{ fontSize: "19px" }}
                                  />{" "}
                                </Link>
                              </li>
                            </ul>
                          )}
                        </li>
                      )} */}

                      <li>
                        <NavLink>
                          <FontAwesomeIcon
                            icon={faSchool}
                            className="nav-icon"
                            onClick={() => toggleDropdown("students")}
                          />
                        </NavLink>
                        {/* {activeDropdown === "students" && ( */}
                        {(localStorage.getItem("userRole") === "supperadmin" ||
                          localStorage.getItem("userRole") === "admin") && (
                          <ul className="admin_dropdownicon">
                            <li>
                              <Link to="/studentform">
                                <FontAwesomeIcon
                                  icon={faSchool}
                                  className="nav-icon"
                                  style={{ fontSize: "19px" }}
                                />
                                <FontAwesomeIcon
                                  icon={faAdd}
                                  className="nav-icon"
                                  style={{ fontSize: "19px" }}
                                />{" "}
                              </Link>
                            </li>
                            <li>
                              <Link to="/studentadd">
                                <FontAwesomeIcon
                                  icon={faSchool}
                                  className="nav-icon"
                                  style={{ fontSize: "19px" }}
                                />
                                <FontAwesomeIcon
                                  icon={faList}
                                  className="nav-icon"
                                  style={{ fontSize: "19px" }}
                                />{" "}
                              </Link>
                            </li>
                          </ul>
                        )}
                        {/* )} */}
                      </li>
                      {/* <li>
                        <NavLink>
                          <FontAwesomeIcon
                            icon={faDonate}
                            className="nav-icon"
                            onClick={() => toggleDropdown("donation")}
                          />
                        </NavLink>
                        {activeDropdown === "donation" && (
                          <ul className="admin_dropdownicon">
                            <li>
                              <Link to="/donateaddqr">
                                <FontAwesomeIcon
                                  icon={faQrcode}
                                  className="nav-icon"
                                  style={{ fontSize: "19px" }}
                                />{" "}
                              </Link>
                            </li>
                            <li>
                              <Link to="/donate_account_add">
                                <FontAwesomeIcon
                                  icon={faFileInvoice}
                                  className="nav-icon"
                                  style={{ fontSize: "19px" }}
                                />{" "}
                              </Link>
                            </li>
                          </ul>
                        )}{" "}
                      </li> */}
                    </ul>
                  )}
                </div>
                <div className="right-arrow" id="right-arrow">
                  <i data-feather="arrow-right"></i>
                </div>
              </div>
            </nav>
          </header>

          <div
            className="page-body"
            style={{
              marginLeft: isSidebarExpanded ? "250px" : "70px",
              transition: "margin-left 0.3s ease-out",
            }}
          >
            {/* Content goes here */}

            <div className="container-fluid">
              <div className="row" style={{ paddingTop: "20px" }}>
                {localStorage.getItem("userRole") === "supperadmin" ? (
                  <div className="col-sm-6 col-xl-3 col-lg-6">
                    <div className="card o-hidden">
                      <div className="bg-primary b-r-4 card-body">
                        <div className="d-flex static-top-widget">
                          <div className="align-self-center text-center">
                            <FontAwesomeIcon icon={faUserTie} />
                          </div>
                          <div className="flex-grow-1">
                            <span className="m-0">
                              <h4 style={{ color: "white" }}>Admin</h4>
                            </span>
                            <Link to="/adminadd">
                              {" "}
                              <h6
                                style={{ color: "white" }}
                                className="mb-0 counter"
                              >
                                more info{" "}
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  style={{ color: "#ffffff" }}
                                />
                              </h6>
                            </Link>
                            {/* <i className="icon-bg" data-feather="database"></i> */}
                            <FontAwesomeIcon
                              icon={faUserTie}
                              className="icon-bg"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                {localStorage.getItem("userRole") === "supperadmin" && (
                  <div className="col-sm-6 col-xl-3 col-lg-6">
                    <div className="card o-hidden">
                      <div className="bg-secondary b-r-4 card-body">
                        <div className="d-flex static-top-widget">
                          <div className="align-self-center text-center">
                            <FontAwesomeIcon icon={faBuildingColumns} />
                          </div>
                          <div className="flex-grow-1">
                            <h4 style={{ color: "white" }}>Institution</h4>
                            <Link to="/institution">
                              <h6
                                style={{ color: "white" }}
                                className="mb-0 counter"
                              >
                                more info{" "}
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  style={{ color: "#ffffff" }}
                                />
                              </h6>
                            </Link>
                            <FontAwesomeIcon
                              icon={faBuildingColumns}
                              className="icon-bg"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {(localStorage.getItem("userRole") === "supperadmin" ||
                  localStorage.getItem("userRole") === "admin") && (
                  <div className="col-sm-6 col-xl-3 col-lg-6">
                    <div className="card o-hidden">
                      <div className="bg-primary b-r-4 card-body">
                        <div className="d-flex static-top-widget">
                          <div className="align-self-center text-center">
                            {" "}
                            <FontAwesomeIcon icon={faSchool} />
                          </div>
                          <div className="flex-grow-1">
                            <span className="m-0">
                              <h4 style={{ color: "white" }}>Student</h4>
                            </span>
                            <Link to="/studentadd">
                              {" "}
                              <h6
                                style={{ color: "white" }}
                                className="mb-0 counter"
                              >
                                more info{" "}
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  style={{ color: "#ffffff" }}
                                />
                              </h6>
                            </Link>
                            {/* <i className="icon-bg" data-feather="message-circle">                       </i> */}
                            <FontAwesomeIcon
                              icon={faSchool}
                              className="icon-bg"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {(localStorage.getItem("userRole") === "supperadmin" ||
                  localStorage.getItem("userRole") === "admin" ) && (
                  <div className="col-sm-6 col-xl-3 col-lg-6">
                    <div className="card o-hidden">
                      <div className="bg-primary b-r-4 card-body">
                        <div className="d-flex static-top-widget">
                          <div className="align-self-center text-center">
                            {" "}
                            <FontAwesomeIcon icon={faWallet} />
                          </div>
                          <div className="flex-grow-1">
                            <span className="m-0">
                              <h4 style={{ color: "white" }}>Wallet</h4>
                            </span>
                            <Link to="/wallet">
                              {" "}
                              <h6
                                style={{ color: "white" }}
                                className="mb-0 counter"
                              >
                                more info{" "}
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  style={{ color: "#ffffff" }}
                                />
                              </h6>
                            </Link>
                            {/* <i className="icon-bg" data-feather="message-circle">                       </i> */}
                            <FontAwesomeIcon
                              icon={faWallet}
                              className="icon-bg"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                  {localStorage.getItem("userRole") === "supperadmin" && (
                  <div className="col-sm-6 col-xl-3 col-lg-6">
                    <div className="card o-hidden">
                      <div className="bg-secondary b-r-4 card-body">
                        <div className="d-flex static-top-widget">
                          <div className="align-self-center text-center">
                            <FontAwesomeIcon icon={faHandHoldingDollar} />
                          </div>
                          <div className="flex-grow-1">
                            <h4 style={{ color: "white" }}>Fund Request</h4>

                            {pendingCount > 0 && (
                <span className="badge bg-danger mb-2">
                  {pendingCount} Pending
                </span>
              )}
                            <Link to="/fund-request-page">
                              <h6
                                style={{ color: "white" }}
                                className="mb-0 counter"
                              >
                                more info{" "}
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  style={{ color: "#ffffff" }}
                                />
                              </h6>
                            </Link>
                            <FontAwesomeIcon
                              icon={faBuildingColumns}
                              className="icon-bg"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}


         
                  <div className="col-sm-6 col-xl-3 col-lg-6">
                    <div className="card o-hidden">
                      <div className="bg-primary b-r-4 card-body">
                        <div className="d-flex static-top-widget">
                          <div className="align-self-center text-center">
                            {" "}
                            <FontAwesomeIcon icon={faDonate} />
                          </div>
                          <div className="flex-grow-1">
                            <span className="m-0">
                              <h4 style={{ color: "white" }}>Add Fund</h4>
                            </span>
                            <Link to="/walletpage">
                              {" "}
                              <h6
                                style={{ color: "white" }}
                                className="mb-0 counter"
                              >
                                more info{" "}
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  style={{ color: "#ffffff" }}
                                />
                              </h6>
                            </Link>
                            {/* <i className="icon-bg" data-feather="message-circle">                       </i> */}
                            <FontAwesomeIcon
                              icon={faWallet}
                              className="icon-bg"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                

                {localStorage.getItem("userRole") === "institute" ? (
                  <div className="col-sm-6 col-xl-3 col-lg-6">
                    <div className="card o-hidden">
                      <div className="bg-primary b-r-4 card-body">
                        <div className="d-flex static-top-widget">
                          <div className="align-self-center text-center">
                            <FontAwesomeIcon icon={faGraduationCap} />
                          </div>
                          <div className="flex-grow-1">
                            <span className="m-0">
                              <h4 style={{ color: "white" }}>Add Course</h4>
                            </span>
                            <Link to="/tailoring">
                              <h6
                                style={{ color: "white" }}
                                className="mb-0 counter"
                              >
                                more info{" "}
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  style={{ color: "#ffffff" }}
                                />
                              </h6>
                            </Link>
                            <FontAwesomeIcon
                              icon={faGraduationCap}
                              className="icon-bg"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}

                {localStorage.getItem("userRole") === "supperadmin" ? (
                  <div className="col-sm-6 col-xl-3 col-lg-6">
                    <div className="card o-hidden">
                      <div className="bg-primary b-r-4 card-body">
                        <div className="d-flex static-top-widget">
                          <div className="align-self-center text-center">
                            <FontAwesomeIcon icon={faClipboard} />
                          </div>
                          <div className="flex-grow-1">
                            <span className="m-0">
                              <h4 style={{ color: "white" }}>our details</h4>
                            </span>
                            <Link to="/addourdetails">
                              <h6
                                style={{ color: "white" }}
                                className="mb-0 counter"
                              >
                                more info{" "}
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  style={{ color: "#ffffff" }}
                                />
                              </h6>
                            </Link>
                            {/* <Scissors className="icon-bg"/> */}
                            <FontAwesomeIcon
                              icon={faClipboard}
                              className="icon-bg"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                
 {localStorage.getItem("userRole") === "supperadmin" ? (
                  <div className="col-sm-6 col-xl-3 col-lg-6">
                    <div className="card o-hidden">
                      <div className="bg-primary b-r-4 card-body">
                        <div className="d-flex static-top-widget">
                          <div className="align-self-center text-center">
                            <FontAwesomeIcon icon={faClipboard} />
                          </div>
                          <div className="flex-grow-1">
                            <span className="m-0">
                              <h4 style={{ color: "white" }}>Meeting regestation</h4>
                            </span>
                            <Link to="/viewmeeting">
                              <h6
                                style={{ color: "white" }}
                                className="mb-0 counter"
                              >
                                more info{" "}
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  style={{ color: "#ffffff" }}
                                />
                              </h6>
                            </Link>
                            {/* <Scissors className="icon-bg"/> */}
                            <FontAwesomeIcon
                              icon={faClipboard}
                              className="icon-bg"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}


                 {localStorage.getItem("userRole") === "supperadmin" ? (
                  <div className="col-sm-6 col-xl-3 col-lg-6">
                    <div className="card o-hidden">
                      <div className="bg-primary b-r-4 card-body">
                        <div className="d-flex static-top-widget">
                          <div className="align-self-center text-center">
                            <FontAwesomeIcon icon={faClipboard} />
                          </div>
                          <div className="flex-grow-1">
                            <span className="m-0">
                              <h4 style={{ color: "white" }}>Meeting Pending</h4>
                            </span>
                            <Link to="/meetingpending">
                              <h6
                                style={{ color: "white" }}
                                className="mb-0 counter"
                              >
                                more info{" "}
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  style={{ color: "#ffffff" }}
                                />
                              </h6>
                            </Link>
                            {/* <Scissors className="icon-bg"/> */}
                            <FontAwesomeIcon
                              icon={faClipboard}
                              className="icon-bg"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}



               

               
                 {localStorage.getItem("userRole") === "supperadmin" ? (
                  <div className="col-sm-6 col-xl-3 col-lg-6">
                    <div className="card o-hidden">
                      <div className="bg-primary b-r-4 card-body">
                        <div className="d-flex static-top-widget">
                          <div className="align-self-center text-center">
                            <FontAwesomeIcon icon={faClipboard} />
                          </div>
                          <div className="flex-grow-1">
                            <span className="m-0">
                              <h4 style={{ color: "white" }}>view interview </h4>
                            </span>
                            <Link to="/viewinterview">
                              <h6
                                style={{ color: "white" }}
                                className="mb-0 counter"
                              >
                                more info{" "}
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  style={{ color: "#ffffff" }}
                                />
                              </h6>
                            </Link>
                            {/* <Scissors className="icon-bg"/> */}
                            <FontAwesomeIcon
                              icon={faClipboard}
                              className="icon-bg"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}




                {localStorage.getItem("userRole") === "supperadmin" ? (
                  <div className="col-sm-6 col-xl-3 col-lg-6">
                    <div className="card o-hidden">
                      <div className="bg-primary b-r-4 card-body">
                        <div className="d-flex static-top-widget">
                          <div className="align-self-center text-center">
                            <FontAwesomeIcon icon={faClipboard} />
                          </div>
                          <div className="flex-grow-1">
                            <span className="m-0">
                              <h4 style={{ color: "white" }}>
                                Exam rank list
                              </h4>
                            </span>
                            <Link to="/exam_rank_list">
                              <h6
                                style={{ color: "white" }}
                                className="mb-0 counter"
                              >
                                more info{" "}
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  style={{ color: "#ffffff" }}
                                />
                              </h6>
                            </Link>
                            {/* <Scissors className="icon-bg"/> */}
                            <FontAwesomeIcon
                              icon={faClipboard}
                              className="icon-bg"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}




                {localStorage.getItem("userRole") === "supperadmin" ? (
                  <div className="col-sm-6 col-xl-3 col-lg-6">
                    <div className="card o-hidden">
                      <div className="bg-primary b-r-4 card-body">
                        <div className="d-flex static-top-widget">
                          <div className="align-self-center text-center">
                            <FontAwesomeIcon icon={faClipboard} />
                          </div>
                          <div className="flex-grow-1">
                            <span className="m-0">
                              <h4 style={{ color: "white" }}>
                                Exam aplication's
                              </h4>
                            </span>
                            <Link to="/allapplications">
                              <h6
                                style={{ color: "white" }}
                                className="mb-0 counter"
                              >
                                more info{" "}
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  style={{ color: "#ffffff" }}
                                />
                              </h6>
                            </Link>
                            {/* <Scissors className="icon-bg"/> */}
                            <FontAwesomeIcon
                              icon={faClipboard}
                              className="icon-bg"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                {localStorage.getItem("userRole") === "supperadmin" ? (
                  <div className="col-sm-6 col-xl-3 col-lg-6">
                    <div className="card o-hidden">
                      <div className="bg-primary b-r-4 card-body">
                        <div className="d-flex static-top-widget">
                          <div className="align-self-center text-center">
                            <FontAwesomeIcon icon={faClipboard} />
                          </div>
                          <div className="flex-grow-1">
                            <span className="m-0">
                              <h4 style={{ color: "white" }}>All Students</h4>
                            </span>
                            <Link to="/allstudent">
                              <h6
                                style={{ color: "white" }}
                                className="mb-0 counter"
                              >
                                more info{" "}
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  style={{ color: "#ffffff" }}
                                />
                              </h6>
                            </Link>
                            {/* <Scissors className="icon-bg"/> */}
                            <FontAwesomeIcon
                              icon={faClipboard}
                              className="icon-bg"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                {localStorage.getItem("userRole") === "supperadmin" ? (
                  <div className="col-sm-6 col-xl-3 col-lg-6">
                    <div className="card o-hidden">
                      <div className="bg-primary b-r-4 card-body">
                        <div className="d-flex static-top-widget">
                          <div className="align-self-center text-center">
                            <FontAwesomeIcon icon={faClipboard} />
                          </div>
                          <div className="flex-grow-1">
                            <span className="m-0">
                              <h4 style={{ color: "white" }}>All Questions</h4>
                            </span>
                            <Link to="/allquestions">
                              <h6
                                style={{ color: "white" }}
                                className="mb-0 counter"
                              >
                                more info{" "}
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  style={{ color: "#ffffff" }}
                                />
                              </h6>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                {localStorage.getItem("userRole") === "supperadmin" ? (
                  <div className="col-sm-6 col-xl-3 col-lg-6">
                    <div className="card o-hidden">
                      <div className="bg-primary b-r-4 card-body">
                        <div className="d-flex static-top-widget">
                          <div className="align-self-center text-center">
                            <FontAwesomeIcon icon={faClipboard} />
                          </div>
                          <div className="flex-grow-1">
                            <span className="m-0">
                              <h4 style={{ color: "white" }}>Exam Mark </h4>
                            </span>
                            <Link to="/exammarks">
                              <h6
                                style={{ color: "white" }}
                                className="mb-0 counter"
                              >
                                more info{" "}
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  style={{ color: "#ffffff" }}
                                />
                              </h6>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                {localStorage.getItem("userRole") === "supperadmin" ? (
                  <div className="col-sm-6 col-xl-3 col-lg-6">
                    <div className="card o-hidden">
                      <div className="bg-primary b-r-4 card-body">
                        <div className="d-flex static-top-widget">
                          <div className="align-self-center text-center">
                            <FontAwesomeIcon icon={faClipboard} />
                          </div>
                          <div className="flex-grow-1">
                            <span className="m-0">
                              <h4 style={{ color: "white" }}>Exam Schedule</h4>
                            </span>
                            <Link to="/examschedule">
                              <h6
                                style={{ color: "white" }}
                                className="mb-0 counter"
                              >
                                more info{" "}
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  style={{ color: "#ffffff" }}
                                />
                              </h6>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
                {localStorage.getItem("userRole") === "supperadmin" ? (
                  <div className="col-sm-6 col-xl-3 col-lg-6">
                    <div className="card o-hidden">
                      <div className="bg-primary b-r-4 card-body">
                        <div className="d-flex static-top-widget">
                          <div className="align-self-center text-center">
                            <FontAwesomeIcon icon={faFile} />
                          </div>
                          <div className="flex-grow-1">
                            <span className="m-0">
                              <h4 style={{ color: "white" }}>certifacate</h4>
                            </span>
                            <Link to="/approvecertificate">
                              <h6
                                style={{ color: "white" }}
                                className="mb-0 counter"
                              >
                                more info{" "}
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  style={{ color: "#ffffff" }}
                                />
                              </h6>
                            </Link>

                            <FontAwesomeIcon
                              icon={faFile}
                              className="icon-bg"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>

        {customizersetting && <div className="customizer-container"></div>}

        <footer
          className="footer"
          style={{
            marginLeft: isSidebarExpanded ? "250px" : "70px",
            transition: "margin-left 0.3s ease-out",
          }}
        >
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6 footer-copyright">
                <p className="mb-0">
                  Copyright 2022 © Maran Software Solutions.
                </p>
              </div>
              <div className="col-md-6">
                <p className="pull-right mb-0">
                  Hand crafted & made with &nbsp;<i className="fa fa-heart"></i>
                </p>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Admin;
